import { ServiceContext } from 'utilities/service.utils';
import { getJRSToken } from './reports.service';

export const AppReportingService = new ServiceContext(
  process.env.REACT_APP_REPORTING_SERVER_URL,
  async (headers: any) => {
    const { token } = await getJRSToken();
    headers['pp'] = token;
    headers['accept'] = 'application/json';
    return headers;
  }
);

export default AppReportingService;
